<template>
  <div>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-12">
        <dl class="row mb-5">
          <dd class="col-sm-12 mb-0 fw-700 text-info">Client information</dd>
          <dd class="col-sm-4 mb-0">Maturing leas id</dd>
          <dd class="col-sm-8 mb-0">
            {{ propsData.id }}
          </dd>
          <dd class="col-sm-4 mb-0">Name</dd>
          <dd class="col-sm-8 mb-0">
            {{ propsData.client }}
          </dd>
          <dd class="col-sm-4 mb-0">Email</dd>
          <dd class="col-sm-8 mb-0">
            {{ propsData.clientEmail }}
          </dd>
          <dd class="col-sm-4 mb-0">Mobile</dd>
          <dd class="col-sm-8 mb-0">
            {{ propsData.clientMobileNumber }}
          </dd>
        </dl>

        <div>
          <div class="form-group multiselect">
            <multiselect
              v-model="objDealer"
              :options="getDealerDropdown"
              placeholder=""
              label="name"
              track-by="name"
            >
            </multiselect>
            <label class="typo__label floatingLabel">Dealer</label>
          </div>

          <div class="form-group multiselect">
            <multiselect
              v-model="objDealerStaff"
              :options="getDealerStaffDropdown"
              placeholder=""
              label="name"
              track-by="name"
            >
            </multiselect>
            <label class="typo__label floatingLabel">Dealer staff</label>
          </div>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              id="position"
              placeholder=" "
              autocomplete="off_position"
              v-model="dealerStaffEmail"
              disabled
            />
            <label class="floatingLabel" for="position">Dealer email</label>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="text-right">
      <button
        type="button"
        @click="fnCreateQuote()"
        class="btn btn-primary btn-sm mr-2"
      >
        <b-spinner small v-if="is_spinActive"></b-spinner>
        Create
      </button>
      <button type="button" class="btn btn-dark btn-sm" @click="hideModal">
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Multiselect from 'vue-multiselect'
import * as messageService from '../../../services/message.service'
import * as maturingLeasService from '../../../services/maturingLeas.service'

export default {
  name: 'SectionCreateNewQuote',
  props: {
    propsData: {
      type: Object,
      required: true
    }
  },
  components: {
    Multiselect
  },
  data() {
    return {
      errors: {},
      clientEmail: '',
      objDealer: {},
      objDealerStaff: {},
      dealerStaffEmail: '',
      is_spinActive: false,
      confirmData: {}
    }
  },
  computed: {
    ...mapGetters([
      'getDealerDropdown',
      'getDealerStaffDropdown',
      'getUserById',
      'getMaturingLeasPaginateData',
      'getMaturingLeasPaginate'
    ]),
    newDealerId() {
      return this.objDealer.id
    },
    newDealerUserId() {
      return this.objDealerStaff.id
    }
  },
  methods: {
    ...mapActions(['fetchDealerStaffDropdown', 'fetchMaturingLeasPaginate']),
    hideModal() {
      this.$emit('closeModal')
    },

    /**
     * For Create quote
     */
    fnCreateQuote: async function () {
      try {
        this.is_spinActive = true
        const response = await maturingLeasService.copyQuote({
          oldQuoteId: this.propsData.id,
          newDealerId: this.newDealerId,
          newDealerUserId: this.newDealerUserId
        })

        if (response.status === 200) {
          this.confirmData = response.data.data
          let otherData = {
            confirmData: this.confirmData,
            objDealer: this.objDealer,
            objDealerStaff: this.objDealerStaff
          }

          this.$emit('quoteCreated', 'openConfirmation', otherData)
        }

        this.is_spinActive = false
        messageService.fnSweetAlertSuccessToast(
          'Create new quote',
          'Sent successfully'
        )
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break
          case 500:
            messageService.fnSweetAlertErrorToast(
              'Create new quote',
              error.response.data.message
            )
            break
          default:
            messageService.fnSweetAlertErrorToast(
              'Create new quote',
              'Something wrong'
            )
            break
        }
      }
    }
  },
  watch: {
    objDealer: function (val) {
      this.objDealerStaff = ''
      this.dealerStaffEmail = ''

      this.fetchDealerStaffDropdown(val.id)
    },
    objDealerStaff: function (val) {
      this.dealerStaffEmail = ''
      this.dealerStaffEmail = val.email
    }
  }
}
</script>
